// removed by extract-text-webpack-plugin
module.exports = {"root":"_6678db40","root--small":"b3650ce3","icon-close":"c05b4e26"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/SimpleImagePreview/index.styl
// module id = 5230
// module chunks = 39